export default __webpack_public_path__ + "static/media/portfolio-202.a51f833a.jpg";